let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6eGRY")).then(() => parcelRequire('gm23K'));